import 'Styles/breadcrumb.scss';

import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { goBack } from 'react-router-redux';

import { resetOverlay } from 'Actions/UiActions';
import { trackGAEvent } from 'Actions/adsActions';

import uiSelector from 'Selectors/uiSelectors';

class overlayComponent extends React.Component {
	shouldComponentUpdate( nextProps ) {
		return (
			nextProps.headerOverflowOpened !== this.props.headerOverflowOpened ||
			nextProps.searchBarOpened !== this.props.searchBarOpened ||
			nextProps.sidebarOpened !== this.props.sidebarOpened ||
			nextProps.globalLoading !== this.props.globalLoading
		);
	}

	resetThisOverlay = () => {
		if( this.props.sidebarOpened ) {
			this.props.dispatch( goBack() );
		}
		this.props.dispatch( resetOverlay() );
		// Record the Google Analytics event.
		this.props.dispatch( trackGAEvent( false, 'overlayClose', 'uiAction', 'tap' ) );
	};

	overlayClass() {
		return ( this.props.headerOverflowOpened || this.props.searchBarOpened || this.props.sidebarOpened || this.props.globalLoading ) ?
			' opened' :
			'';
	}

	globalLoadingClass() {
		return this.props.globalLoading ? ' opened' : '';
	}

	render() {
		return (
			<div className={ 'overlayMask' + this.overlayClass() } onClick={ this.resetThisOverlay } >
				<span className={ 'globalLoading' + this.globalLoadingClass() }>{ this.props.globalLoading }</span>
			</div>
		);
	}
}

overlayComponent.propTypes = {
	dispatch: PropTypes.func.isRequired,
	globalLoading: PropTypes.string.isRequired,
	headerOverflowOpened: PropTypes.bool.isRequired,
	searchBarOpened: PropTypes.bool.isRequired,
	sidebarOpened: PropTypes.bool.isRequired
};

export default connect( uiSelector )( overlayComponent );



// WEBPACK FOOTER //
// ./src/components/common/overlayComponent.js